export default __webpack_public_path__ + "static/media/phone-small-1c94a266.dd1978d2.png";